/**
 * 自定义 Image Loader
 * 解决 basePath + unoptimized 模式下图片路径不自动拼 basePath 的问题
 */
export default function imageLoader({ src }) {
  // CDN 绝对路径，不处理
  if (src.startsWith("http")) {
    return src;
  }
  // 本地图片，拼上 basePath
  return `/pointsmall${src.startsWith("/") ? "" : "/"}${src}`;
}
